// Light/dark theme handling. The initial theme is applied by an inline script
// in public/index.html so the page never flashes the wrong colors.

const STORAGE_KEY = 'theme';
const META_COLORS = { dark: '#07090f', light: '#ffffff' };

export const getTheme = () =>
  document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';

export const setTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', META_COLORS[theme]);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    // Storage can be unavailable (private mode); the theme still applies for this visit.
  }
};

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
};
